import Toastr from "../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  loading: false,
  saving: false,
  logs: [],
  logsLoading: false,
  setting: null,
};

let changes = null;

export default function faitReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response);

  switch (action.type) {
    case 'FAIT_SETTING_CREATE_PENDING':
      return {
        ...state,
        loading: true,
        saving: true,
      };

    case 'FAIT_SETTING_CREATE_REJECTED':
      if (response?.data) {
        Toastr.handleShow(
          response.data.success,
          response.data.error,
          response.data.status_code
        );
      }
      changes = {
        loading: false,
        saving: false,
      };
      return {
        ...state,
        ...changes,
      };

    case 'FAIT_SETTING_CREATE_FULFILLED':
      Toastr.handleShow(
        true,
        response?.meta?.message || 'Fait settings saved successfully',
        201
      );
      changes = {
        loading: false,
        saving: false,
        setting: response?.store_setting || state.setting,
      };
      return {
        ...state,
        ...changes,
      };

    case 'FAIT_LOGS_LOAD_PENDING':
      return {
        ...state,
        logsLoading: true,
      };

    case 'FAIT_LOGS_LOAD_REJECTED':
      changes = {
        logsLoading: false,
      };
      return {
        ...state,
        ...changes,
      };

    case 'FAIT_LOGS_LOAD_FULFILLED':
      return {
        ...state,
        logsLoading: false,
        logs: response?.logs || response?.integration_logs || response?.data?.logs || [],
      };

    default:
      return state;
  }
}
